export default __webpack_public_path__ + "static/media/exhibitions2.634dfd2e.png";